import { useEffect, useState } from 'react';
import type { InvitationItem, MeResponse } from '@kassa/shared';
import { api, ApiError } from '../api';

interface Props {
  onAccepted: (me: MeResponse) => void;
}

const RESULT_TEXT: Record<string, string> = {
  expired: 'Dəvətin müddəti bitib.',
  done: 'Bu dəvətə artıq baxılıb.',
  not_found: 'Dəvət tapılmadı.',
};

// Hesabın aldığı dəvətlər (mühasib): qəbul və ya rədd. Dəvət yoxdursa heç nə göstərilmir.
export function InvitationsPanel({ onAccepted }: Props) {
  const [items, setItems] = useState<InvitationItem[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const load = () =>
    api
      .myInvitations()
      .then(setItems)
      .catch(() => setItems([]));

  useEffect(() => {
    load();
  }, []);

  async function decide(it: InvitationItem, accept: boolean) {
    setBusy(true);
    setError(null);
    try {
      const r = accept ? await api.acceptInvitation(it.id) : await api.rejectInvitation(it.id);
      if (r.result === 'accepted' && r.me) {
        onAccepted(r.me);
        return;
      }
      if (RESULT_TEXT[r.result]) setError(RESULT_TEXT[r.result]);
      await load();
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Əməliyyat alınmadı');
    } finally {
      setBusy(false);
    }
  }

  if (items.length === 0 && !error) return null;
  return (
    <section className="card" aria-label="Dəvətlər">
      <h2>Dəvətlər</h2>
      {error && (
        <p className="bad" role="alert">
          {error}
        </p>
      )}
      <ul className="product-list">
        {items.map((it) => (
          <li key={it.id} className="product-row">
            <span className="product-name">
              {it.tenantName}
              <span className="muted small"> · {it.invitedBy} sizi mühasib kimi dəvət edir</span>
            </span>
            <span className="muted small">{new Date(it.expiresAt).toLocaleDateString('az-AZ')}-dək</span>
            <span className="toolbar">
              <button type="button" className="btn-primary btn-small" disabled={busy} onClick={() => decide(it, true)}>
                Qəbul et
              </button>
              <button type="button" className="link-btn" disabled={busy} onClick={() => decide(it, false)}>
                Rədd et
              </button>
            </span>
          </li>
        ))}
      </ul>
    </section>
  );
}
